export const ScreenSize = {
  mobileWidth: 767,
  modalWidth: 1024
}